import type React from 'react'
import styled from 'styled-components'

import InformationItem from '@/components/EntityPanels/InformationItem'
import type { CompanyCredit } from '@/types/Activity'

import CompanyCCJ, { Container } from './CompanyCCJ'

interface Props {
  credit: CompanyCredit
}

const VerifiedBy = styled.p`
  margin: 0;
`

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
`

const CCJRow = styled(Container)`
  font-weight: bold;
`

const OrganisationCreditDetails: React.FC<Props> = ({ credit }) => {
  return (
    <div>
      <h2>For Profit Company</h2>
      {credit?.verifiedBy !== undefined && (
        <VerifiedBy>
          The organisation details has been verified by{' '}
          <strong>{credit.verifiedBy.name}</strong> ({credit.verifiedBy.email})
        </VerifiedBy>
      )}
      <DetailRow>
        <InformationItem header="Credit Score">
          <p>{credit.creditScore} out of 100</p>
        </InformationItem>
        <InformationItem header="Credit Limit">
          <p>£{credit.creditLimit}</p>{' '}
        </InformationItem>
      </DetailRow>
      <div>
        <h2>Adverse Credit (CCJs)</h2>
        {credit.ccJs.length > 0 ? (
          <div>
            <p>A total of {credit.ccJs.length} CCJ(s) have been added to this company.</p>
            <CCJRow>
              <p>Court Date</p>
              <p>Amount</p>
              <p>Active/Satisfied</p>
            </CCJRow>
            {credit.ccJs.map((ccj, index) => (
              <CompanyCCJ key={index} ccj={ccj} />
            ))}
          </div>
        ) : (
          <div>
            <p>No CCJs have been added against the company.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default OrganisationCreditDetails
